var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('solid-box',{attrs:{"priceRate":_vm.tradeSum.priceRate[_vm.transferVariety],"title":_vm.moduleName}},[_c('div',{directives:[{name:"auto-size",rawName:"v-auto-size"}],ref:"container",staticClass:"container"})])}
var staticRenderFns = []

export { render, staticRenderFns }